import { SVGProps } from "react";

const STIOpencores = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-label="OpenCores" role="img" viewBox="0 0 512 512" width="1em" height="1em" {...props}><rect width={512} height={512} rx="15%" fill="#27529d" /><g fill="none" stroke="#fff" strokeWidth={48}><circle cy={192} cx={192} r={84} /><circle strokeDasharray="0 67 396 999" cy={320} cx={320} r={84} /></g></svg>;

export { STIOpencores };